<template>
  <footer>
    <cookie-law
      theme="Kulibri"
      buttonText="OK"
      :message="cookieMmessage"
    ></cookie-law>
    <div class="container" v-if="visibleNav">
      <div class="row">
        <div class="col-md p-2">
          <router-link class="nav-link d-inline" to="/">{{
            $t('footer.about')
          }}</router-link>
        </div>
        <div class="col-md p-2">
          <router-link class="nav-link d-inline" to="/dataprivacy">{{
            $t('footer.privacy')
          }}</router-link>
        </div>
        <div class="col-md p-2">
          <router-link class="nav-link d-inline" to="/agb">{{
            $t('footer.terms')
          }}</router-link>
        </div>
        <div class="col-md p-2">
          <router-link class="nav-link d-inline" to="/">{{
            $t('footer.contact')
          }}</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import CookieLaw from 'vue-cookie-law';

export default {
  name: 'Footer',
  components: {
    CookieLaw,
  },
  props: {},
  data() {
    return {
      cookieMmessage:
        'Wir verwenden Cookies, um Ihnen den bestmöglichen Service zu gewährleisten. Mit der Nutzung der Seite stimmen Sie der Verwendung von Cookies zu.',
    };
  },
  computed: {
    ...mapState(['visibleNav']),
  },
  methods: {
    showModal() {
      //console.log('Show the modal')
      //   this.$emit('showModal')
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
footer {
  .container {
    max-width: 800px;
  }

  background-color: #eeeeee;
}
</style>
